<template>
    <div>
        <section class="messagepage">
            <v-container v-if="thread">
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <v-row>
                            <v-col class="d-flex pbottom-none">
                                <message-avatar :size="64" :type="thread.type"
                                                :text="thread.thread_name"></message-avatar>
                                <div class="messagepage__infotext">
                                    <h1 class="headline">{{ thread.thread_name }}</h1>

                                    <p v-if="thread.type === 'public'">Toto je veřejný chat, vaší zprávu uvidí všichni
                                        členové.</p>
                                    <p v-else-if="thread.type === 'team'">Toto je týmový chat, vaší zprávu uvidí všichni
                                        členové vašeho týmu.</p>
                                    <p v-else-if="thread.type === 'direct'">Toto je soukromý chat, vaší zprávu uvidí
                                        pouze příjemce.</p>
                                </div>
                            </v-col>
                        </v-row>
                        <div class="write-message">
                            <v-card>
                                <v-card-title class="write-message__newmsg"><p>Nová zpráva</p></v-card-title>
                                <v-card-text>
                                    <v-form>
                                        <v-textarea
                                            v-model.trim="message"
                                            rows="1"
                                            dark
                                            label="TEXT ZPRÁVY"
                                        ></v-textarea>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" dark :disabled="!canSend" :loading="isSending"
                                           @click.prevent="onSend">Odeslat zprávu
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </div>
                        <v-card
                            v-for="message in thread.messages"
                            :key="message.id"
                            class="mb-3 messagepage__wrap"
                        >

                            <div class="messagepage__msg">
                                <v-row>
                                    <v-col cols="16">
                                        <v-row>
                                            <v-col class="d-flex">
                                                <message-avatar :size="48" type="direct"
                                                                :text="message.nickname"></message-avatar>
                                                <div class="messagepage__msgauthor">
                                                    <router-link class="messagepage__title"
                                                                 :to="{ name: 'userDetail', params: { id: message.id_author } }">
                                                        {{ message.nickname }}
                                                    </router-link>
                                                    <span class="messagepage__date">{{ message.added.date | formatToday }}</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="16" offset="0" md="15" offset-md="1">
                                        <p class="messagepage__content">{{ message.content }}</p>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        <!--section class="history-block">
            <v-container>
                <v-row>
                    <v-col cols="14" offset="1" md="12" offset-md="2">
                        <h2 class="section-subtitle--linenone">NA SMÍCHOVĚ DRŽÍME PIVO PO SVÝM UŽ 150 LET</h2>
                        <p>A tak s námi letos oslavte Dny českého piva pivními rituály Smíchova.</p>
                        <v-btn
                            color="primary"
                            large
                            text
                            :to="{ name: 'registration' }"
                        >Přidat se na akci
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </section-->
    </div>
</template>

<script>
    import MessageAvatar from '../components/Message/MessageAvatar';
    import { MESSAGE_SEND_REQUEST, MESSAGE_THREAD_REQUEST, RELOAD_THREAD_REQUEST } from '../store/actions/message'

    export default {
        components: {
            MessageAvatar,
        },
        props: {
            id: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                thread: null,
                isSending: false,
                message: '',
                polling: false,
            };
        },
        computed: {
            canSend () {
                return this.message !== '';
            },
        },
        async mounted () {
            this.thread = await this.$store.dispatch('message/' + MESSAGE_THREAD_REQUEST, { id: this.id });
            this.polling = setInterval(async () => {
                this.thread.messages = await this.$store.dispatch('message/' + RELOAD_THREAD_REQUEST, { id: this.id });
            }, 3000);
        },
        beforeDestroy () {
            clearInterval(this.polling);
        },
        methods: {
            async onSend () {
                if (!this.canSend) {
                    return;
                }

                const message = {
                    message: this.message,
                    thread: this.id,
                };

                try {
                    this.isSending = true;
                    await this.$store.dispatch('message/' + MESSAGE_SEND_REQUEST, message);
                    this.message = '';
                    this.$toast.success('Zpráva byla úspěšně odeslána.');
                } catch (e) {
                    this.$toast.error('Došlo k chybě při posílání zprávy. Zkuste to později.');
                } finally {
                    this.isSending = false;
                }
            },
        },
    }
</script>
